import axios from "axios";
import {
  API_URL,
  GYPSYBALL_PYTHON_API_URL,
  GYPSYBALL_PYTHON_API_TOKEN,
} from "configs";

import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";

import { v4 as uuidv4 } from "uuid";
export const COMMITEE_REQUEST = "COMMITEE_REQUEST";
export const COMMITEE_SUCCESS = "COMMITEE_SUCCESS";
export const USER_ACCESS = "USER_ACCESS";
export const COMMITEE_USERS_ACCESS = "COMMITEE_USERS_ACCESS";
export const COMMITEE_VALIDATION_ERROR = "COMMITEE_VALIDATION_ERROR";
const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_COMMITEE_FEILD_VALIDATION_ERROR =
  "HIDE_COMMITEE_FEILD_VALIDATION_ERROR";
export const REDIRECT_TO_COMMITTE_LIST = "REDIRECT_TO_COMMITTE_LIST";

export const COMMITEE_GET_SUCCESS = "COMMITEE_GET_SUCCESS";
export const COMMITEE_DROPDOWN_LIST_SUCCESS = "COMMITEE_DROPDOWN_LIST_SUCCESS";
export const COMMITEE_SERVER_SUCCESS = "COMMITEE_SERVER_SUCCESS";

const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const commiteeRequest = () => ({
  type: COMMITEE_REQUEST,
});

export const commiteeServerListSuccess = () => ({
  type: COMMITEE_SERVER_SUCCESS,
});

const commiteeListSuccess = (commiteeList) => ({
  type: COMMITEE_SUCCESS,
  commiteeList: commiteeList,
});

export const commiteeFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const validationError = (notification) => ({
  type: COMMITEE_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const commiteeAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(commiteeSuccessNotification(message));
  dispatch(redirectToCommiteeList());
};

export const redirectToCommiteeList = () => ({
  type: REDIRECT_TO_COMMITTE_LIST,
});

const getCommiteeSuccess = (response, action) => ({
  type: COMMITEE_GET_SUCCESS,
  record: response,
  actionType: action,
});

const getUSerSuccess = (getUser) => ({
  type: USER_ACCESS,
  getUser: getUser,
});

const getCommiteeUsersSuccess = (getCommiteeUsers) => ({
  type: COMMITEE_USERS_ACCESS,
  getCommiteeUsers: getCommiteeUsers,
});

const commiteeSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

export const hideCommiteeValidationError = (feild_key) => ({
  type: HIDE_COMMITEE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const userFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "user/getAll", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      // params: { object_viewed_id: object_viewed_id }
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getUSerSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getCommiteeUsersList = (id, action) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "commitee/getUsersById/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getCommiteeUsersSuccess(response.data));
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const commiteeListFetch = (user_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "commitee", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(commiteeListSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const addCommitee = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "commitee/create", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        commiteeAddUpadteSuccess(
          "Commitee Added Successfully",
          "create",
          dispatch
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceFailure("The name has already been taken"))
      }
    );
  };
};

export const updateCommitee = (data) => {
  const id = data.id; // Make sure `id` exists on `data`
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + "commitee/update/" + id, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data, // send whole object (must match Laravel expectations)
      });

      commiteeAddUpadteSuccess(
        "Commitee Updated Successfully",
        "update",
        dispatch
      );
    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};

export const getCommiteeById = (id, action) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "commitee/getById/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getCommiteeSuccess(response.data, action));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const deleteCommitee = (id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(commiteeRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "commitee/delete/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(commiteeSuccessNotification("Commitee deleted successfully"));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(commiteeFailure(err));
    }
  } catch (e) {
    dispatch(commiteeFailure("Unable to perform action.Something went wrong"));
  }
};
